/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_CalculatingInputs */

const en_onboarding_calculating = /** @type {(inputs: Onboarding_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating`)
};

const es_onboarding_calculating = /** @type {(inputs: Onboarding_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando`)
};

/**
* | output |
* | --- |
* | "Calculating" |
*
* @param {Onboarding_CalculatingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_calculating = /** @type {((inputs?: Onboarding_CalculatingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_CalculatingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_calculating(inputs)
	return en_onboarding_calculating(inputs)
});